import React, { Component } from "react";
import AlumniDescription from "./AlumniDescription";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

const NAVY    = "#1A2B4A";
const NAVY_2  = "#243B66";
const GOLD    = "#C8991A";
const CRIMSON = "#B22222";
const INK     = "#374151";
const BORDER  = "#e8e0d0";

const list = [
  { title: "Alumni Association", link: "/alumni/committee" },
  { title: "Alumni Support", link: "/alumni/support" },
  { title: "Alumni Events", link: "/alumni/events" },
  { title: "Alumni Achievements", link: "/alumni/achievements" },
  { title: "Prominent Alumni", link: "/alumni/prominent" },
  { title: "Alumni Members", link: "/alumni/list" },
];

class AlumniComponent extends Component {
  state = {
    link: "",
  };

  componentDidMount() {
    this.setState({ link: this.props.match.params.link });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.link !== this.props.match.params.link) {
      this.setState({ link: this.props.match.params.link });
    }
  }

  isActive = (path) => path === `/alumni/${this.state.link}`;

  go = (path) => {
    this.props.history.push(path);
  };

  render() {
    return (
      <div>
        <BreadCrumbOwn title="Alumni" />

        <div className="al-page">
          <div className="al-page__inner">
            {/* SIDEBAR */}
            <aside className="al-side">
              <div className="al-side__header">
                <span className="al-side__eyebrow">Our Network</span>
                <span className="al-side__title">Alumni</span>
              </div>

              <nav className="al-side__nav" aria-label="Alumni sections">
                {list.map((el, index) => {
                  const active = this.isActive(el.link);
                  return (
                    <button
                      type="button"
                      key={index}
                      onClick={() => this.go(el.link)}
                      className={`al-side__item${active ? " is-active" : ""}`}
                    >
                      <span>{el.title}</span>
                    </button>
                  );
                })}
              </nav>
            </aside>

            {/* CONTENT */}
            <main className="al-content">
              <div className="al-content__body">
                <AlumniDescription type={this.state.link} />
              </div>
            </main>
          </div>
        </div>

        <style>{`
          .al-page {
            background: #fff;
            padding: 32px 0 56px;
          }
          .al-page__inner {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
            display: grid;
            grid-template-columns: 280px 1fr;
            gap: 28px;
            align-items: start;
          }

          /* ── Sidebar ── */
          .al-side {
            background: #fff;
            border: 1px solid ${BORDER};
            border-radius: 10px;
            box-shadow: 0 4px 18px rgba(26,43,74,0.06);
            overflow: hidden;
            position: sticky;
            top: 16px;
            max-height: calc(100vh - 32px);
            display: flex;
            flex-direction: column;
            font-family: 'Lato', sans-serif;
          }
          .al-side__header {
            background: linear-gradient(135deg, ${NAVY} 0%, ${NAVY_2} 100%);
            color: #fff;
            padding: 18px 20px 16px;
            border-bottom: 3px solid ${GOLD};
            display: flex;
            flex-direction: column;
            gap: 4px;
          }
          .al-side__eyebrow {
            color: ${GOLD};
            font-size: 10px;
            font-weight: 700;
            letter-spacing: 2px;
            text-transform: uppercase;
          }
          .al-side__title {
            font-family: 'Playfair Display', Georgia, serif;
            font-size: 18px;
            font-weight: 700;
            letter-spacing: 0.3px;
          }
          .al-side__nav {
            overflow-y: auto;
            padding: 6px 0;
            scrollbar-width: thin;
            scrollbar-color: ${GOLD} transparent;
          }
          .al-side__nav::-webkit-scrollbar { width: 6px; }
          .al-side__nav::-webkit-scrollbar-thumb {
            background: rgba(200,153,26,0.4);
            border-radius: 3px;
          }
          .al-side__item {
            width: 100%;
            text-align: left;
            background: transparent;
            border: none;
            border-left: 3px solid transparent;
            padding: 10px 16px 10px 18px;
            font-family: 'Lato', sans-serif;
            font-size: 13.5px;
            font-weight: 500;
            color: ${INK};
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            transition: background 0.15s, color 0.15s, border-color 0.15s;
            line-height: 1.35;
          }
          .al-side__item:hover {
            background: rgba(200,153,26,0.08);
            color: ${NAVY};
            border-left-color: ${GOLD};
          }
          .al-side__item.is-active {
            background: rgba(178,34,34,0.06);
            color: ${CRIMSON};
            border-left-color: ${CRIMSON};
            font-weight: 700;
          }

          /* ── Content panel ── */
          .al-content {
            background: #fff;
            min-width: 0;
          }
          .al-content__body {
            padding: 8px 0 0 8px;
            color: ${INK};
            font-family: 'Lato', sans-serif;
          }

          @media (max-width: 960px) {
            .al-page__inner {
              grid-template-columns: 1fr;
            }
            .al-side {
              position: relative;
              top: 0;
              max-height: none;
            }
            .al-side__nav {
              max-height: 320px;
            }
            .al-content__body {
              padding: 8px 0 0 0;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default AlumniComponent;
